export default "__VITE_ASSET__Cg6DPR9I__"